import { MenuItem, IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import "./status.select.css";
import BaseInput from "./baseInput";
import ClearIcon from "@/assets/icons/clear-icon.svg";

interface IStatusSelect {
    value?: boolean | null;
    title: string;
    width?: string;
    updateStatus: (arg: boolean | null) => void;
}

const BaseChangeStatus: FC<IStatusSelect> = (props: IStatusSelect) => {
    const { t } = useTranslation();
    const selectOptions = [
        { id: null, text: t("general.All") },
        { id: true, text: t("general.Active") },
        { id: false, text: t("general.Inactive") },
    ];
    return (
        <BaseInput
            select
            label={props.title}
            size="small"
            onChange={(e: any) => {
                if (e.target.value) {
                    const option = selectOptions.find(({ text }) => text === e.target.value);
                    if (option) props.updateStatus(option.id);
                }
            }}
            value={selectOptions.find(({ id }) => id === props.value)?.text}
            sx={{ width: props.width ?? "100%" }}
            InputProps={{
                endAdornment: (
                    <IconButton
                        className="select-clear-icon"
                        sx={{
                            visibility: props.value === true || props.value === false ? "visible" : "hidden",
                        }}
                        onClick={() => props.updateStatus(null)}
                    >
                        <img src={ClearIcon} alt="Clear icon" />
                    </IconButton>
                ),
            }}
        >
            {selectOptions.map(({ text }) => (
                <MenuItem key={text} value={text}>
                    {text}
                </MenuItem>
            ))}
        </BaseInput>
    );
};

export default BaseChangeStatus;
